/**
 * Веб-замена AppState из React Native.
 *
 * В мобилке через AppState ловили возврат приложения из фона, чтобы добить
 * зависший SSE-стрим. В браузере роль фона играет скрытая вкладка, плюс
 * добавляется то, чего в приложении не было — потеря и восстановление сети.
 */

export type VisibilityListener = (state: 'active' | 'hidden') => void
export type NetworkListener = (online: boolean) => void

export function onVisibilityChange(listener: VisibilityListener): () => void {
  const handler = () => {
    listener(document.visibilityState === 'visible' ? 'active' : 'hidden')
  }

  document.addEventListener('visibilitychange', handler)
  return () => document.removeEventListener('visibilitychange', handler)
}

export function onNetworkChange(listener: NetworkListener): () => void {
  const online = () => listener(true)
  const offline = () => listener(false)

  window.addEventListener('online', online)
  window.addEventListener('offline', offline)

  return () => {
    window.removeEventListener('online', online)
    window.removeEventListener('offline', offline)
  }
}

export function isOnline(): boolean {
  return typeof navigator === 'undefined' ? true : navigator.onLine
}
